import { memo } from 'react'
import { useRestaurantDetailContext } from '@/features/restaurants/restaurant-detail/restaurant-detail-context'
import { SvgOutlinedPlace } from '@/icons/svg-outlined-place'

export const RestaurantDetailLocation = memo(() => {
    const { restaurant } = useRestaurantDetailContext()

    if (!restaurant || (!restaurant.address && !restaurant.city && !restaurant.zipCode)) return null

    return (
        <div className="flex flex-row items-center justify-between px-1 w-full md:w-fit">
            <div className="flex flex-row items-center justify-start w-full gap-x-2 md:gap-x-1.5 overflow-hidden">
                <div className="md:block hidden">
                    <SvgOutlinedPlace
                        color="black"
                        size={19}
                        style={{ position: 'relative', bottom: '0.5px' }}
                    />
                </div>

                {restaurant.zipCode && (
                    <p className="font-semibold hidden md:block text-[15px] md:text-[16px] whitespace-nowrap">
                        {restaurant.zipCode} {restaurant.city?.name}
                    </p>
                )}

                {restaurant.address && (
                    <p
                        className="font-medium md:font-normal text-[15px] md:text-[16px] text-ellipsis overflow-hidden
                            whitespace-nowrap relative"
                    >
                        {restaurant.address}
                    </p>
                )}
            </div>
        </div>
    )
})

RestaurantDetailLocation.displayName = 'RestaurantDetailLocation'
